import NavBar from '../components/navbar'
import Hero from '../components/purchase_page/hero'
import Description from '../components/purchase_page/description'
import Guest_Speakers from '../components/purchase_page/guest_speaker'
import Tickets from '../components/purchase_page/tickets'
import Footer from '../components/footer'


export default function Purchase({principal,setPrincipal}){
    return (
      <div>
        <NavBar principal={principal} setPrincipal={setPrincipal}></NavBar>
        <Hero></Hero>
        <Description></Description>
        <Guest_Speakers></Guest_Speakers>
        <Tickets></Tickets>
        <Footer></Footer>
      </div>
      
    )
}